import { makeStyles } from '@material-ui/core';

import { Theme } from '@mui/material';

export interface StyleProps {
  lineClamp?: number;
}

export interface Props extends StyleProps {
  text: string;
}

const useStyles = makeStyles<Theme, StyleProps>(() => ({
  lineClamp: {
    overflow: 'hidden',
    display: '-webkit-box',
    '-webkit-box-orient': 'vertical',
    '-webkit-line-clamp': ({ lineClamp }) => lineClamp,
    lineClamp: ({ lineClamp }) => lineClamp,
    whiteSpace: 'break-spaces!important' as 'break-spaces'
  }
}));

/**
 * Component that truncates the text at a specific number of lines.
 * @param lineClamp - maximum number of visible lines
 * @param text - text
 */
const LineClamp = ({ lineClamp, text }: Props) => {
  const classes = useStyles({ lineClamp: lineClamp });

  return <div className={classes.lineClamp}>{text}</div>;
};

export default LineClamp;
